import React from 'react';
import { Search } from 'lucide-react';
interface HeroProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}
export function Hero({
  searchQuery,
  setSearchQuery
}: HeroProps) {
  return <section className="mx-auto max-w-7xl px-4 pt-24 pb-16 sm:px-6 lg:px-8" data-id="element-87">
      <div className="flex flex-col items-center text-center" data-id="element-88">
        <div className="mb-6 inline-flex items-center rounded-full border border-neutral-200 bg-neutral-50 px-3 py-1 text-xs font-medium text-neutral-600" data-id="element-89">
          <span className="mr-1.5" data-id="element-90">🇮🇳</span> Made in India
        </div>

        <h1 className="max-w-3xl text-4xl font-bold tracking-tight text-neutral-900 sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05]" data-id="element-91">
          The home for India's <br className="hidden sm:block" data-id="element-92" />
          AI startups.
        </h1>

        <p className="mt-6 max-w-2xl text-lg text-neutral-500" data-id="element-93">
          Discover the fastest-growing artificial intelligence companies
          building from India for the world.
        </p>

        <div className="mt-10 w-full max-w-xl relative" data-id="element-94">
          <div className="relative flex items-center" data-id="element-95">
            <Search className="absolute left-4 h-5 w-5 text-neutral-400" data-id="element-96" />
            <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search by name, category, or keyword..." className="w-full rounded-xl border border-neutral-200 bg-white py-4 pl-12 pr-16 text-sm text-neutral-900 placeholder:text-neutral-400 focus:border-neutral-300 focus:outline-none focus:ring-4 focus:ring-neutral-100 transition-all shadow-sm" data-id="element-97" />
            <div className="absolute right-4 hidden sm:flex items-center gap-1" data-id="element-98">
              <kbd className="inline-flex h-5 items-center justify-center rounded border border-neutral-200 bg-neutral-50 px-1.5 text-[10px] font-medium text-neutral-500" data-id="element-99">
                ⌘
              </kbd>
              <kbd className="inline-flex h-5 items-center justify-center rounded border border-neutral-200 bg-neutral-50 px-1.5 text-[10px] font-medium text-neutral-500" data-id="element-100">
                K
              </kbd>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-4 text-sm text-neutral-500" data-id="element-101">
          <div className="flex items-center gap-1.5" data-id="element-102">
            <div className="h-1.5 w-1.5 rounded-full bg-green-500" data-id="element-103" />
            250+ startups
          </div>
          <span className="text-neutral-300" data-id="element-104">•</span>
          <div className="flex items-center gap-1.5" data-id="element-105">30+ categories</div>
          <span className="text-neutral-300" data-id="element-106">•</span>
          <div className="flex items-center gap-1.5" data-id="element-107">Updated weekly</div>
        </div>
      </div>
    </section>;
}